'use client';

import { cn } from '@/lib/utils';
import { ChevronRight } from 'lucide-react';
import Link from 'next/link';
import { Fragment } from 'react';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}

export function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className={cn('flex items-center space-x-2', className)}>
      {items.map((item, index) => (
        <Fragment key={index}>
          {index > 0 && <span className="text-gray-400 text-lg font-light"> / </span>}
          {item.href && index < items.length - 1 ? (
            <Link
              href={item.href}
              className="text-lg text-gray-600 hover:text-gray-900 transition-colors font-medium"
            >
              {item.label}
            </Link>
          ) : (
            <span
              className={cn(
                'text-lg font-medium',
                index === items.length - 1 ? 'text-gray-900' : 'text-gray-600'
              )}
            >
              {item.label}
            </span>
          )}
        </Fragment>
      ))}
    </nav>
  );
}
